<template>
  <div class="growth-book-form">
    <div class="top">
      <el-button
          @click="$router.go(-1)"
          size="medium"
        >返回</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="submitForm"
        >保存</el-button>
    </div>
    <el-form
      label-width="140px"
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-form-item
        label="组件编码"
        prop="assemblyNo"
      >
        <el-input
        size="medium"
          placeholder="1-20个字符"
          maxlength="20"
          show-word-limit
          v-model.trim="form.assemblyNo"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="组件类型"
        prop="type"
      >
        <el-select
          size="medium"
          placeholder="请选择"
          value-key="code"
          v-model="form.type" 
        >
          <el-option
            :label="type.value"
            :value="type"
            :key="typeIdx"
            v-for="(type, typeIdx) in typeList"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="横版张数"
        prop="xPhotoNum"
      >
        <el-input
          placeholder="0~4的正整数"
          maxlength="1"
          v-model.trim="form.xPhotoNum" size="medium"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="竖版张数"
        prop="yPhotoNum"
      >
        <el-input
          placeholder="0~4的正整数"
          maxlength="1"
          v-model.trim="form.yPhotoNum" size="medium"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="color-picker-wrapper"
        label="页面字体颜色"
        prop="fontColor" 
      >
        <el-color-picker v-model="form.fontColor"></el-color-picker>
      </el-form-item>
      <el-form-item
        label="组件背景图"
        prop="backLogo"
      >
        <uploader
          showMode="image"
          showResult="image"
          :multiple="false"
          :value="form.backLogo"
          :extList="['png', 'jpg', 'jpeg', 'bmp']"
        ></uploader>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
/* utils */
import mixin from "@/mixins/windowResize";

/* components */
import Uploader from "@/components/Uploader/WebUploader";

/* api */
import { findDicsByCode } from "@/api/common/common";
import {
  getGrowthBookAssemblyInfoById,
  addGrowthBookAssembly,
  editGrowthBookAssembly,
} from "@/api/growthBook";

export default {
  mixins: [mixin],
  components: { Uploader },
  computed: {},
  watch: {
    "form.backLogo": {
      handler(n, o) {
        this.$refs["form"].validateField("backLogo");
      },
      deep: true,
    },
  },
  data() {
    let validateType = (rule, value, callback) => {
      let code = value.code;
      if (!code) callback(new Error("请选择组件类型"));
      else callback();
    };
    let validatePhotoNum = (rule, value, callback) => {
      let reg = /^([0-4]{1})$/;
      if (reg.test(value)) callback();
      else callback(new Error("请输入0~4的正整数"));
    };
    const validateBackLogo = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error("请上传组件背景图"));
      } else {
        this.$refs["form"].clearValidate("backLogo");
        callback();
      }
    };

    return {
      // 新增 / 编辑
      formType: "add",
      // 保存成功后提示语
      messsage: "保存成功",
      // 封面可上传类型
      logoExtList: ["jpeg", "jpg", "bmp", "png"],
      // 类型筛选列表
      typeList: [],
      // 组件ID
      id: "",
      // 请求表单
      form: {
        // 组件编码
        assemblyNo: "",
        // 组件类型
        type: {
          code: "",
        },
        // 横版张数
        xPhotoNum: "",
        // 竖版张数
        yPhotoNum: "",
        // 页面字体颜色
        fontColor: "#000",
        // 组件背景图
        backLogo: [],
      },
      rules: {
        assemblyNo: [
          { required: true, message: "请输入组件编码", trigger: "blur" },
        ],
        type: [
          {
            required: true,
            message: "请选择组件类型",
            validator: validateType,
            trigger: "change",
          },
        ],
        xPhotoNum: [
          {
            required: true,
            message: "请输入0~4的正整数",
            validator: validatePhotoNum,
            trigger: "blur",
          },
        ],
        yPhotoNum: [
          {
            required: true,
            message: "请输入0~4的正整数",
            validator: validatePhotoNum,
            trigger: "blur",
          },
        ],
        fontColor: [
          {
            required: true,
            message: "请选择页面字体颜色",
            trigger: "change",
          },
        ],
        backLogo: [
          {
            required: true,
            message: "请选择组件背景图",
            validator: validateBackLogo,
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let p = Promise.all([this.findDicsByCode()])
        .then((res) => {
          let id = this.$route.query.id;
          if (id) {
            this.formType = "edit";
            this.id = id;
            this.getGrowthBookAssemblyInfoById();
          } else this.formType = "add";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    findDicsByCode() {
      return findDicsByCode({
        dicCode: "archivesActivityType",
      })
        .then((res) => {
          let _res = res.data;
          if (_res.code != 200) return Promise.reject(_res.msg);
          else return _res.data;
        })
        .then((data) => {
          if (Array.isArray(data)) {
            this.typeList = data.map((item) =>
              JSON.parse(JSON.stringify(item))
            );
            this.form.type = this.typeList[0];
          }
        });
    },
    getGrowthBookAssemblyInfoById() {
      getGrowthBookAssemblyInfoById({
        id: this.id,
      }).then((data) => {
        if (data) {
          this.form.assemblyNo = data.assemblyNo;
          this.form.type = this.typeList.find(
            (item) => item.code == data.typeCode
          );
          this.form.xPhotoNum = data.xPhotoNum;
          this.form.yPhotoNum = data.yPhotoNum;
          this.form.fontColor = data.fontColor;
          this.form.backLogo = [{ fileUrl: data.backLogo }];
        }
      });
    },
    addGrowthBookAssembly(form) {
      addGrowthBookAssembly(form).then((data) => {
        this.$message({
          message: this.messsage,
          type: "success",
        });
        this.$router.replace({
          path: "index",
        });
      });
    },
    editGrowthBookAssembly(form) {
      editGrowthBookAssembly(form).then((data) => {
        this.$message({
          message: this.messsage,
          type: "success",
        });
        this.$router.replace({
          path: "index",
        });
      });
    },
    // 提交
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = {
            assemblyNo: this.form.assemblyNo,
            typeCode: this.form.type.code,
            typeName: this.form.type.value,
            xPhotoNum: this.form.xPhotoNum,
            yPhotoNum: this.form.yPhotoNum,
            fontColor: this.form.fontColor,
            backLogo: this.form.backLogo[0].fileUrl,
            assemblyJson: "",
          };
          if (this.formType == "add") {
            this.addGrowthBookAssembly(form);
          } else {
            form.id = this.id;
            this.editGrowthBookAssembly(form);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.growth-book-form {
  padding:12px; 
  .top{
      border-bottom: 1px solid #e4e7ed;
      padding-bottom: 10px;
  }
  .el-form {
    width: 810px;
    margin: 0 auto;
    overflow: auto;
     padding-top:10px;
    /deep/ .color-picker-wrapper {
      .el-form-item__content {
        height: 40px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/growthBook/form.vue